{
  "common": {
    "save": "保存修改",
    "cancel": "取消",
    "delete": "删除",
    "loading": "加载中…",
    "language": "语言",
    "all": "全部",
    "actions": "操作",
    "search": "查询",
    "noIssues": "✓ 未发现问题，可以发布"
  },
  "nav": {
    "rates": "费率管理",
    "simulator": "计价模拟器",
    "events": "活动日历",
    "lot": "场地设置",
    "orders": "订单与会话",
    "revenue": "营收与打款",
    "promotions": "停车金活动",
    "team": "账号与日志"
  },
  "shell": {
    "currentLot": "当前场地",
    "lotCount": "{{code}} · 共 {{count}} 个场地",
    "online": "场地已上线",
    "offline": "场地未上线",
    "offlineNote": "临时下线不影响进行中的会话",
    "owner": "业主",
    "staff": "员工",
    "signOut": "退出",
    "loadingLots": "正在加载场地…",
    "menu": "菜单",
    "closeMenu": "关闭菜单"
  },
  "login": {
    "title": "ParkingPay 业主后台",
    "subtitle": "费率配置 · 计价模拟 · 营收与打款",
    "email": "邮箱",
    "password": "密码",
    "signIn": "登录",
    "signingIn": "登录中…",
    "failed": "登录失败",
    "devHint": "开发环境种子账号：业主 maria@loopparking.com / 员工 devon@loopparking.com，密码 ParkingPay!2026。员工可查订单与车牌，不可改费率、不可看打款。"
  },
  "rates": {
    "title": "费率管理",
    "hint": "直接录入车主最终支付的价格。保存生成新版本，进行中的会话锁定开始时的版本。",
    "history": "变更历史",
    "saveDraft": "保存草稿",
    "publish": "发布 v{{version}}",
    "loadFailed": "无法加载费率",
    "saveFailed": "保存失败",
    "publishFailed": "发布失败",
    "colMax": "时长上限",
    "colPrice": "最终价格",
    "within": "{{duration}}内",
    "minimumMinutes": "最小购买时长（分钟）",
    "incrementMinutes": "计费增量（分钟）",
    "dailyCap": "24 小时封顶价",
    "extraDay": "超 24h 续日单价",
    "preflight": "发布前自检",
    "specials": "特殊费率",
    "specialWindow": "{{from}}–{{to}} 入场",
    "specialExit": "，{{time}} 前离场",
    "specialNote": "与分档表比价取低，车主端标注费率名称",
    "panel": "多条费率同时命中时自动取对车主最优价并在车主端标注费率名称；活动价强制覆盖，不参与比价。\n保存即生成新版本并记录生效时间，进行中的会话锁定开始时的版本。",
    "published": "生效中",
    "draft": "草稿",
    "superseded": "已被替代",
    "notPublished": "未发布",
    "editedAt": "编辑于 {{time}}"
  },
  "simulator": {
    "title": "计价模拟器与自检",
    "hint": "业主敢于自助配置费率的前提：先看到车主会付多少，再决定要不要发布。",
    "startAt": "入场时刻（车场当地时间）",
    "minutes": "停放分钟",
    "requestedMinutes": "车主输入时长",
    "entitlementMinutes": "实际有效时长",
    "run": "计算价格",
    "running": "计算中…",
    "appliedRate": "命中费率",
    "standardTier": "标准分档",
    "beatsTier": "优于分档基价 {{price}}",
    "finalPrice": "最终价格",
    "selfCheck": "费率自检",
    "curve": "24 小时价格曲线",
    "curveDuration": "停放时长",
    "hours": "{{count}} 小时",
    "minutesShort": "{{count}} 分钟",
    "total": "总价",
    "arrivesAt": "{{hour}}:00 入场",
    "panel": "曲线按「入场时刻」采样，展示同一停放时长在一天中不同时间的最终价格。命中早鸟 / 夜间 / 活动价时会立刻反映在柱高上。"
  },
  "events": {
    "title": "活动日历与活动价",
    "hint": "球赛日固定价，强制覆盖所有其他费率，不参与比价。",
    "new": "+ 新建活动",
    "newTitle": "新建停车金活动",
    "editTitle": "编辑停车金活动",
    "name": "活动名称",
    "startsAt": "开始",
    "endsAt": "结束",
    "price": "活动价",
    "lots": "适用场地（不选则全部）",
    "saveEvent": "保存活动",
    "createFailed": "创建失败",
    "colName": "活动名称",
    "colDate": "日期",
    "colTime": "时间范围",
    "colPrice": "活动价",
    "colLots": "适用场地",
    "panel": "活动生效期间，车主端在价格旁展示活动名称与「活动价」标识。活动价不与分档表 / 早鸟价比价，直接覆盖。"
  },
  "lotSetup": {
    "title": "场地设置",
    "createTitle": "新建车场",
    "hint": "15 分钟内完成建场并上线收费，无需平台介入。临时下线不影响进行中的会话。",
    "online": "已上线",
    "offline": "临时下线",
    "draft": "草稿",
    "name": "场地名称",
    "nameZh": "场地中文名称",
    "address": "街道地址",
    "city": "城市",
    "state": "州",
    "postalCode": "邮编",
    "latitude": "纬度",
    "longitude": "经度",
    "capacity": "车位总数",
    "maximumCapacity": "最大车位数",
    "capacityLimitActive": "停车中或付款中的车辆达到 {{count}} 辆后，将停止接受新车辆付款。",
    "capacityLimitHint": "请输入停车场同时可容纳的最大车辆数量。",
    "spaceNumberStart": "起始车位号",
    "spaceNumberHint": "手动输入 4 位起始号，结束号会根据车位总数自动计算。",
    "spaceNumberRange": "车位号范围 {{start}}–{{end}}",
    "invalidSpaceRange": "请输入 4 位起始号，并确保完整范围不超过 9999。",
    "numberingTitle": "车位编号",
    "numberingDescription": "可管理 4 位车位编号；关闭编号时，则按最大车位数限制新停车。",
    "numberingEnabled": "要求输入车位号",
    "numberingEnabledDescription": "如果停车场没有编号车位，请关闭此开关。",
    "numberingDisabled": "未启用",
    "numberingCurrentRange": "当前编号范围",
    "numberingEdit": "修改编号",
    "numberingReview": "查看变更",
    "numberingCancel": "取消",
    "numberingProtected": "此设置会影响停车场内已打印的车位标牌，因此受到保护；顶部的普通保存不会修改编号。",
    "numberingConfirmTitle": "确认修改车位编号",
    "numberingConfirmDescription": "请仔细核对此设置。只有启用车位编号后，司机才需要输入车位号。",
    "numberingCurrent": "当前",
    "numberingNew": "修改后",
    "numberingSpaceCount": "{{count}} 个车位",
    "numberingConfirmAction": "确认并更新",
    "numberingSaved": "车位编号已更新",
    "numberingSaveFailed": "车位编号更新失败",
    "heightCm": "限高（厘米，可选）",
    "timezone": "时区",
    "evChargers": "EV 充电桩",
    "status": "收费状态",
    "availability": "人工车位状态",
    "availabilityUpdated": "管理员更新 · {{time}}",
    "availabilityUnknownTime": "尚未更新",
    "availabilityStatus": {
      "unknown": "未知",
      "available": "有空位",
      "busy": "繁忙",
      "full": "已满"
    },
    "accessEn": "入口指引（英文）",
    "accessZh": "入口指引（中文）",
    "photos": "入口照片",
    "uploadPhotos": "上传照片",
    "photoFormats": "JPG、PNG 或 WebP · 每张最大 8 MB",
    "photoCount": "已选 {{count}} / {{max}} 张",
    "photoAlt": "入口照片 {{number}}",
    "primaryPhoto": "主图",
    "makePrimary": "设为主图",
    "removePhoto": "移除照片",
    "uploading": "正在上传照片",
    "retryUpload": "重新上传",
    "photoUploadFailed": "照片上传失败",
    "photoTypeError": "请选择 JPG、PNG 或 WebP 图片。",
    "photoSizeError": "每张照片不能超过 8 MB。",
    "photoLimit": "每个车场最多上传 {{count}} 张照片。",
    "newLot": "新建车场",
    "cancelCreate": "取消",
    "create": "创建草稿",
    "save": "保存修改",
    "saved": "车场已保存",
    "saveFailed": "车场保存失败",
    "noLotsOwner": "当前还没有车场。新建第一个草稿后，系统会生成场地编号和二维码。",
    "noLotsStaff": "当前运营方尚未配置车场。",
    "hours": "营业时间（可按星期分别配置）",
    "qrTitle": "场地二维码",
    "qrAlt": "{{lot}} 场地二维码",
    "preview": "预览落地页",
    "downloadQr": "下载",
    "printQr": "打印",
    "qrAfterCreate": "创建草稿后，系统会自动生成场地编号和二维码。",
    "weekday": {
      "1": "周一",
      "2": "周二",
      "3": "周三",
      "4": "周四",
      "5": "周五",
      "6": "周六",
      "7": "周日"
    }
  },
  "orders": {
    "title": "订单与进行中会话",
    "hint": "车牌查询仅供人工抽查，V1 不构成执法系统。",
    "exportCsv": "导出 CSV",
    "inProgress": "进行中（{{count}}）",
    "autoRefresh": "每 30 秒自动刷新",
    "colPlate": "车牌",
    "colSpace": "车位号",
    "colLot": "车场",
    "colStart": "开始",
    "colExpiry": "到期",
    "colRemaining": "剩余",
    "colPaid": "已付",
    "colRefunded": "已退款",
    "colActions": "操作",
    "manage": "管理",
    "history": "历史订单",
    "from": "开始日期",
    "to": "结束日期",
    "plateFilter": "车牌（可选）",
    "colRef": "订单号",
    "colTime": "时间",
    "colDuration": "时长",
    "withExtensions": "（含 {{count}} 次续时）",
    "lookupTitle": "车牌查询",
    "lookup": "查询",
    "lookupFailed": "查询失败，请检查车牌格式",
    "paidOk": "有效缴费中",
    "paidOkDetail": "{{lot}} · 到期 {{time}} · 剩余 {{remaining}}",
    "notPaid": "未查询到有效缴费",
    "panel": "V1 仅供人工抽查。当前没有 LPR 或闸机数据源，因此所有巡查记录都会明确标注为人工录入。",
    "manageTitle": "订单操作",
    "close": "关闭",
    "patrolNote": "人工巡查备注",
    "addNote": "添加备注",
    "correctPlate": "更正车牌",
    "reasonRequired": "必须填写原因（至少 5 个字符）",
    "saveCorrection": "保存更正",
    "refund": "订单退款",
    "refundFull": "全额退款",
    "refunded": "已退款",
    "refundHistory": "退款记录",
    "patrolHistory": "巡查记录",
    "none": "暂无",
    "actionFailed": "操作失败"
  },
  "revenue": {
    "title": "营收与打款 · {{month}}",
    "hint": "查看车主最终支付金额、退款、平台服务费和 Stripe 打款。",
    "prevMonth": "上月",
    "nextMonth": "下月",
    "noAccess": "无法加载营收数据（员工账号无权查看）。",
    "transactions": "交易笔数",
    "transactionsSub": "含首付款与续时",
    "grossTotal": "营收总额",
    "grossTotalSub": "车主最终支付",
    "refunds": "退款金额",
    "refundsSub": "本期已受理",
    "platformFee": "平台服务费",
    "platformFeeSub": "按最终价格计",
    "net": "实际到账",
    "netSub": "扣除退款与费用",
    "daily": "每日交易额",
    "noTransactions": "本月无交易",
    "payouts": "打款记录",
    "weekly": "周结算",
    "paid": "已到账",
    "pending": "待打款",
    "noPayouts": "暂无打款记录。结算周期与打款主体由 Stripe Connect 账户配置决定。",
    "panel": "打款周期与打款主体由已连接的 Stripe 账户配置决定。此页面用于核对车主支付与实际到账。"
  },
  "team": {
    "title": "账号、权限与操作日志",
    "hint": "分别设置员工能做什么、能管理哪些停车场。权限和车场范围修改后立即生效。",
    "invite": "邀请员工",
    "name": "姓名",
    "email": "邮箱",
    "owner": "业主",
    "staff": "员工",
    "members": "已加入成员",
    "pendingInvitations": "待接受邀请",
    "noPendingInvitations": "当前没有待接受的邀请。",
    "pending": "待接受",
    "permissions": "员工权限",
    "lotScope": "可管理停车场",
    "lotCount": "已选 {{selected}} / {{total}}",
    "selectAllLots": "全选",
    "clearLots": "清空",
    "allLots": "全部当前及未来停车场",
    "noLots": "请先创建停车场，再邀请员工。",
    "noLotsAssigned": "尚未分配停车场",
    "noPermissions": "尚未分配权限",
    "ownerScope": "全部权限，包含成员管理",
    "editPermissions": "编辑权限与车场",
    "remove": "移除员工",
    "confirmRemove": "确认移除",
    "removeFailed": "无法移除员工",
    "permissionUpdateFailed": "无法更新权限",
    "sendInvite": "发送邀请",
    "sending": "正在发送…",
    "inviteFailed": "邀请失败",
    "invitationSent": "邀请邮件已发送至 {{email}}",
    "resend": "重新发送",
    "resent": "邀请邮件已重新发送。",
    "resendFailed": "无法重新发送邀请",
    "revoke": "撤销邀请",
    "confirmRevoke": "确认撤销",
    "revokeFailed": "无法撤销邀请",
    "expiresAt": "有效期至 {{date}}",
    "nameRequired": "请填写员工姓名。",
    "emailInvalid": "请输入有效邮箱。",
    "permissionRequired": "请至少选择一项权限。",
    "lotRequired": "请至少选择一个停车场。",
    "ownerOnly": "只有业主账号可以管理成员与权限。",
    "auditLog": "操作日志",
    "auditEmpty": "暂无操作记录。",
    "permissionLabels": {
      "lots_manage": "车场设置",
      "rates_manage": "费率与计价",
      "events_manage": "活动价格",
      "orders_manage": "订单与巡查",
      "refunds_manage": "订单退款",
      "revenue_view": "营收与打款",
      "promotions_manage": "停车金活动"
    },
    "permissionDescriptions": {
      "lots_manage": "编辑车场资料、营业时间和照片",
      "rates_manage": "查看、模拟、编辑并发布收费标准",
      "events_manage": "创建和删除特殊活动价格",
      "orders_manage": "查看订单、查车牌、更正车牌和填写巡查备注",
      "refunds_manage": "查看订单并执行全额退款",
      "revenue_view": "查看营收和 Stripe 打款记录",
      "promotions_manage": "创建、调整和撤销停车金活动"
    }
  },
  "acceptInvite": {
    "title": "接受员工邀请",
    "subtitle": "{{name}}，{{organization}} 邀请你加入停车场管理后台。请设置自己的登录密码。",
    "password": "设置密码",
    "passwordHint": "至少 10 位",
    "confirmPassword": "再次输入密码",
    "accept": "接受邀请并登录",
    "accepting": "正在创建账号…",
    "passwordTooShort": "密码至少需要 10 位。",
    "passwordMismatch": "两次输入的密码不一致。",
    "failed": "无法接受邀请",
    "invalidTitle": "邀请链接无效",
    "invalidBody": "该邀请可能已经接受、撤销或过期。请联系邀请你的业主重新发送。"
  },
  "promotions": {
    "title": "停车金活动",
    "hint": "首次安装的设备获得一笔可用于实际停车的余额，按次扣减、余额留存。总预算是唯一的硬上限 —— 设备标识可以被重置，所以务必给活动封顶。",
    "new": "+ 新建活动",
    "name": "活动名称",
    "grant": "单台设备发放（美元）",
    "budget": "总预算",
    "ttl": "有效期（天）",
    "ttlNever": "留空表示永不过期",
    "startsAt": "开始时间",
    "endsAt": "结束时间",
    "localTime": "按当前设备时区输入",
    "create": "创建活动",
    "save": "保存活动",
    "edit": "编辑",
    "createFailed": "创建失败",
    "updateFailed": "保存失败",
    "invalidAmounts": "请输入有效金额，并确保总预算不低于单台发放金额。",
    "invalidTtl": "有效期必须是大于 0 的整数天，或留空表示永不过期。",
    "invalidWindow": "结束时间必须晚于开始时间。",
    "status": {
      "draft": "草稿",
      "active": "进行中",
      "paused": "已暂停",
      "ended": "已结束"
    },
    "activate": "开启",
    "pause": "暂停",
    "end": "结束活动",
    "colName": "活动",
    "colStatus": "状态",
    "colGrant": "单台发放",
    "colBudget": "预算",
    "colGranted": "已发放",
    "colRedeemed": "实际核销",
    "colDevices": "设备数",
    "empty": "还没有活动。",
    "grantsTitle": "发放记录",
    "grantsHint": "用 App 里显示的设备号查询。设备号入库前已哈希，查询时会用同样方式哈希后比对。",
    "deviceSearch": "设备号",
    "clear": "清空",
    "colDevice": "设备（哈希）",
    "colUser": "账号",
    "colAmount": "发放金额",
    "colBalance": "剩余余额",
    "colPlatform": "平台",
    "colGrantedAt": "发放时间",
    "colExpiry": "到期",
    "revoke": "作废",
    "revokeConfirm": "确认作废这笔发放？只会收回未消费的余额，已经发生的停车不会被撤销。",
    "revoked": "已作废",
    "granted": "已发放",
    "grantsEmpty": "没有匹配的发放记录。",
    "never": "永不过期",
    "panel": "停车金是「支付方式」而不是「折扣」，直接抵扣停车最终价格。没被花掉的券不产生任何成本 —— 「实际核销」才是真实支出。"
  },
  "errors": {
    "invalid_credentials": "邮箱或密码不正确。",
    "no_organization": "该账号尚未加入任何停车运营方。",
    "lot_not_found": "车场不存在。",
    "lot_not_owned": "包含不属于本运营方的车场。",
    "short_code_exhausted": "无法分配场地编号，请重试。",
    "space_number_start_required": "启用车位编号前，请设置 4 位起始车位号。",
    "invalid_space_range": "请输入 4 位起始号，并确保完整范围不超过 9999。",
    "invalid_event_window": "活动结束时间必须晚于开始时间。",
    "event_not_found": "活动不存在。",
    "rate_version_not_found": "费率版本不存在。",
    "rate_version_invalid": "费率存在错误，无法发布。",
    "invalid_plate": "车牌只能包含字母与数字，长度 2–10 位。",
    "order_not_found": "订单不存在。",
    "nothing_to_refund": "该订单没有可退款付款。",
    "refund_provider_missing": "该付款缺少支付渠道交易号，无法自动退款。",
    "promotion_name_required": "活动名称不能为空。",
    "grant_must_be_positive": "单台设备发放金额必须大于 0。",
    "budget_below_grant": "总预算不能小于单台设备发放金额。",
    "budget_below_granted": "预算不能低于已发放金额。",
    "promotion_not_found": "活动不存在。",
    "promotion_invalid_window": "活动结束时间必须晚于开始时间。",
    "promotion_active_exists": "当前已有进行中的停车金活动，请先暂停或结束它。",
    "grant_not_found": "发放记录不存在。",
    "forbidden": "当前账号没有该操作权限。",
    "permission_required": "当前账号没有该操作权限。",
    "lot_assignment_required": "请至少选择一个停车场。",
    "lot_assignment_invalid": "所选停车场中有已失效或不属于当前运营方的车场。",
    "team_member_exists": "该邮箱已经是团队成员。",
    "operator_email_in_use": "该邮箱已经用于另一个管理账号。",
    "invitation_email_failed": "邀请邮件发送失败，请稍后重试。",
    "invitation_not_found": "邀请不存在或已失效。",
    "invitation_invalid": "邀请链接无效或已过期。",
    "team_member_not_found": "员工不存在或已被移除。",
    "cannot_remove_self": "不能移除自己的账号。",
    "unauthorized": "请重新登录。",
    "rate_limited": "操作过于频繁，请稍后再试。",
    "internal_error": "服务暂时不可用，请稍后重试。",
    "network_error": "网络不可用，请检查后重试。",
    "photo_empty": "请选择一张非空图片。",
    "photo_too_large": "每张照片不能超过 8 MB。",
    "photo_type_unsupported": "请选择 JPG、PNG 或 WebP 图片。",
    "photo_invalid": "该文件不是有效图片。",
    "photo_storage_unavailable": "照片存储暂时不可用。",
    "unknown_error": "出了点问题，请稍后重试。"
  },
  "issues": {
    "bad_minimum": "最小购买时长必须为正整数分钟",
    "bad_increment": "计费增量必须为正整数分钟",
    "no_tiers": "至少需要一个时长分档",
    "bad_tier": "分档上限必须为正数",
    "bad_price": "分档价格不能为负",
    "duplicate_tier": "存在重复的分档上限",
    "cheaper_when_longer": "较长分档比较短分档更便宜，车主端会标注「更划算」",
    "ladder_gap": "分档未覆盖 24 小时，更长的停放会直接落到 24 小时封顶价",
    "cap_below_ladder": "24 小时封顶价低于最长分档价，长停会比短停便宜",
    "bad_window": "特殊费率的入场窗口结束时间必须晚于开始时间",
    "window_before_open": "特殊费率的入场窗口早于营业时间，发布前需修正",
    "exit_after_close": "特殊费率的离场时限晚于营业结束时间"
  },
  "units": {
    "fullDay": "24 小时",
    "minutes": "{{count}} 分钟",
    "hours": "{{count}} 小时",
    "hoursMinutes": "{{hours}} 小时 {{minutes}} 分"
  }
}
